/**
 * This reducer used to access the last store action.
 * ex: store.getState().lastAction
 */

export const lastActionReducer = (state, action) => {
  return action;
};

export default lastActionReducer;
